import Vue from 'vue'
import ElementUI from 'element-ui'
import localeEN from '../node_modules/element-ui/lib/locale/lang/en'
import localeZH from '../node_modules/element-ui/lib/locale/lang/zh-CN'
import '../theme/index.css'
import VueI18n from 'vue-i18n'
import App from './App'
import router from './router'
import {server} from './utils/http-service'//引用了封装axios文件
import {util} from './utils/util'//引用了封装axios文件
import {qs} from 'qs'
import '@/styles/index.scss'//引用系统公共样式
import {store} from './store/store'//引用store.js
import VueIntro from 'vue-introjs'//引导层
Vue.use(VueIntro);
import 'intro.js/introjs.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import 'amfe-flexible'
Vue.use(Vant);
// import JsonExcel from 'vue-json-excel'
import vueXlsxTable from 'vue-xlsx-table'
import md5 from 'js-md5';
import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts
Vue.prototype.$server=server;//封装了axios
Vue.prototype.$util=util;//封装了util
const locale=localStorage.getItem("language")=="en"?localeEN:localeZH
Vue.use(VueI18n)
Vue.use(ElementUI, { locale })
Vue.use(router)
Vue.use(vueXlsxTable,{rABS:false})
Vue.config.productionTip = false
Vue.prototype.$qs = qs
Vue.prototype.$md5=md5
// Vue.component('downloadExcel', JsonExcel)

// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
  locale: localStorage.getItem("language")=="en"?'en':'zh'?'zh':(this.$util.defLanguage=='en'?'en':'zh'), // 定义默认语言为中文
  messages: {
    'zh': require('@/assets/languages/zh.json'),
    'en': require('@/assets/languages/en.json')
  }
})


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = i18n.t("login.title")
  }
  next()
})

/* eslint-disable no-new */
window.vm=new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js